import { css, sva } from "@agapi/ui/panda/css";

export const successfullPromoStyles = sva({
  slots: ['root', 'button'],
  base: {
    root: {
      justifyItems: "space-between",
      bg: "feedback.success.background",
      color: "feedback.success.foreground",
      rounded: "forms",
      px: "tight",
      py: "3",
      justifyContent: "space-between",
      width: "100%",
      '&[aria-disabled="true"]': {
        bg: "action.disabled.background",
        color: "action.disabled.foreground",
        pointerEvents: "none"
      }
    },
    button: {
      textDecoration: "underline",
      mr: "0"
    }
  }
});
